var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#FB9600",
    rx: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.417 4.777c-.085.026-.155.059-.155.073 0 .018 1.46 1.492 3.247 3.279l3.244 3.246.14.02c.326.044.074.27 3.623-3.284 1.775-1.778 3.226-3.246 3.226-3.26 0-.015-.076-.05-.17-.077-.155-.044-.738-.047-6.588-.044-5.7.003-6.432.006-6.567.047Zm-.847.805c-.052.12-.055.308-.064 4.357-.006 3.697 0 4.25.038 4.38.023.081.056.17.073.193.024.035.487-.413 2.307-2.233L7.204 10 4.931 7.73a221.855 221.855 0 0 0-2.288-2.27c-.012 0-.044.055-.074.122ZM15.072 7.73 12.8 10l2.28 2.28c1.82 1.819 2.283 2.267 2.306 2.232a.89.89 0 0 0 .073-.194c.038-.128.044-.682.038-4.38-.008-4.048-.011-4.236-.064-4.356-.03-.067-.062-.123-.073-.123-.01 0-1.04 1.023-2.29 2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.51 12.871c-1.237 1.24-2.248 2.265-2.248 2.28 0 .014.076.05.17.076.155.043.741.046 6.57.046 5.829 0 6.415-.002 6.57-.046.094-.027.17-.062.17-.077 0-.014-1.014-1.043-2.254-2.288l-2.253-2.261-.715.706c-.604.6-.742.72-.903.796a1.381 1.381 0 0 1-1.228.003c-.164-.079-.298-.196-.9-.793a21.548 21.548 0 0 0-.72-.698c-.006 0-1.026 1.014-2.26 2.256Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.5 2.5h15.004v15H2.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactSupport);
export default __webpack_public_path__ + "static/media/contact-support.5170ccbf09b1ef17c0378ad200ac7801.svg";
export { ForwardRef as ReactComponent };